<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-content">
      <h3>¡Nueva versión disponible!</h3>
      <p>Por favor, actualiza la página para obtener la última versión.</p>
      <button @click="refreshPage">Actualizar ahora</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    refreshPage() {
      window.location.reload(true);
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  max-width: 300px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

button {
  margin-top: 1rem;
  padding: 0.5rem 1.2rem;
  background-color: #349468;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
